import {
    Button,
    CircularProgress,
    Collapse,
    Dialog,
    DialogContent,
    DialogTitle,
    Divider,
    Typography
} from "@mui/material";
import {Flex} from "../../../../../../newShared/components/Layouts";
import colors from "../../../../../../newShared/theme/colors";
import {SectionDetails} from "./components/sectionDetails";
import {MenuIcon} from "./components/menuIcon";
import {
    FlexColumn,
    FlexRow
} from "../../../../../../newShared/components/editorUnion/components/editorTitleWithActionsRow/styled";
import React from "react";
import {SectionsMenuPreview} from "./components/SectionsMenuPreview";
import {TrainingInfoPreview} from "./components/TrainingInfoPreview";
import {usePreviewFinishedTrainingDialog} from "../../../hooks/dialogs/usePreviewFinishedTrainingDialog";


export const PreviewFinishedTrainingDialog = () => { 
    const {isOpen, training, actions, loadings, sectionsMenu, trainingInfo, sectionDetails} = usePreviewFinishedTrainingDialog();

    return(
        <Dialog open={isOpen} onClose={actions.handleClose} fullScreen fullWidth sx={{'.MuiPaper-root': {height: '100vh', width: '100vw'}}}>
            <DialogTitle>
                <Flex w={'100%'} jc={'space-between'} ai={'center'}>
                    <Typography variant={'*h3'} color={colors.grayText}>{training?.trainingName}</Typography>

                    <Flex jc={'space-between'} ai={'center'} gap={'16px'}>
                        <Button variant={'outlined'} size={'small'} onClick={actions.handleClose}>
                            {('Close')}
                        </Button>
                    </Flex>
                </Flex>
            </DialogTitle>

            <DialogContent sx={{display: 'flex', flexDirection: 'column', overflow: 'hidden', width: '100%'}}>
                <FlexRow width={'100%'} height={'100%'} gap={'30px'} overflow={'hidden'} maxWidth={'min(1550px, 90%)'} sx={{marginInline: 'auto'}}>

                    <FlexRow sx={{maxWidth: 'max(30%, 290px)', height: '100%', flexGrow: 1}}>
                        <Collapse in={sectionsMenu.isMenuOpened} orientation={'horizontal'}
                                  sx={{
                                      '.MuiCollapse-wrapperInner': {width: '100%', display: 'flex', flexDirection: 'column', paddingBottom: '16px'},
                                  }}>
                            <FlexColumn sx={{width: '100%', overflow: 'hidden', flexGrow: 1, gap: '16px'}}>
                                <SectionsMenuPreview {...sectionsMenu} />
                                {/**/}
                                <TrainingInfoPreview {...trainingInfo}/>
                            </FlexColumn>
                        </Collapse>
                    </FlexRow>

                    <FlexRow position={'relative'} sx={{flexGrow: 1}}>
                        <Divider orientation={'vertical'} flexItem/>
                        <MenuIcon isOpen={sectionsMenu.isMenuOpened} onClick={sectionsMenu.toggleMenu} />
                    </FlexRow>

                    <FlexRow sx={{width: '100%', height: '100%', flexGrow: 1, overflow: 'hidden'}}>
                        {loadings.isLoadingGetTraining ?
                            <FlexColumn sx={{gap: '16px', width: '100%', height: '100%', alignItems: 'center', justifyContent: 'center'}}>
                                <CircularProgress size={48}/>
                            </FlexColumn>
                            :
                            <SectionDetails section={sectionDetails.section} />
                        }

                    </FlexRow>
                </FlexRow>
            </DialogContent>
        </Dialog>
    )
}